import { useNewTranslations } from '@/common/translations';
import { Section } from '@/ui/components';

import { RowLabelAndCircularGraph, RowLabelAndNumbers, TeamsJerseys } from '../../../components';
import { ApiWidgetType, StatsTypes } from '../../../constants';
import { useStatsData } from '../../../hooks';

const rowHeightClassName = 'h-[40px]';
const columnWidthClassName = 'w-[54px]';

const SeasonStats = () => {
  const translate = useNewTranslations();
  const { teams, widget } = useStatsData({
    widgetType: StatsTypes.SEASON_STATS,
  });

  if (!widget || widget.type !== ApiWidgetType.SEASON_STATS || !widget?.data) {
    return null;
  }

  const { home: homeStats, away: awayStats } = widget.data;

  return (
    <Section name={translate('PreMatchStats.SeasonStats')} contentClassName="flex flex-col gap-2">
      <TeamsJerseys
        homeJerseySrc={teams.home.jersey}
        awayJerseySrc={teams.away.jersey}
        homeTeamName={teams.home.name}
        awayTeamName={teams.away.name}
      />
      <RowLabelAndNumbers
        className={rowHeightClassName}
        numberColumnClassName={columnWidthClassName}
        label={translate('PreMatchStats.GamesPlayed')}
        homeNumber={homeStats.gamesPlayed}
        awayNumber={awayStats.gamesPlayed}
      />
      <RowLabelAndCircularGraph
        label={`% ${translate('PreMatchStats.Victory')}`}
        homeNumber={homeStats.winRate / 100}
        awayNumber={awayStats.winRate / 100}
      />
      <RowLabelAndCircularGraph
        label={`% ${translate('PreMatchStats.AveragePossession')}`}
        homeNumber={homeStats.possession / 100}
        awayNumber={awayStats.possession / 100}
      />
    </Section>
  );
};

export default SeasonStats;
